import React from 'react';
import c from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import s from './SocialButtonBase.scss';
var SocialButtonBase = function (_a) {
    var biData = _a.biData, className = _a.className, labelClassName = _a.labelClassName, onClick = _a.onClick, children = _a.children;
    return (React.createElement(BiButton, { className: c(s['root'], s['updated-ui'], className), biData: biData, onClick: onClick },
        React.createElement("div", { className: c(s['label'], labelClassName) }, children)));
};
SocialButtonBase.displayName = 'SocialButtonBase';
export default SocialButtonBase;
//# sourceMappingURL=SocialButtonBase.js.map